import React from 'react';
import {LayoutDashboard,FlaskConical,FolderKanban,Building2,FileText,Search,ClipboardCheck,Settings,Users,BarChart3,Upload,Link2,Calendar,Briefcase,Sparkles,PenLine,ShieldCheck,Activity,ArrowRight} from 'lucide-react';
const icons={home:LayoutDashboard,formulations:FlaskConical,projects:FolderKanban,partners:Building2,documents:FileText,research:Search,review:ClipboardCheck,settings:Settings,people:Users,reports:BarChart3,upload:Upload,linked:Link2,calendar:Calendar,portfolio:Briefcase,ai:Sparkles,input:PenLine,approval:ShieldCheck,clinical:Activity,next:ArrowRight};
export function iconKey(label='') {
 const value=label.toLowerCase();
 if(/review|qualif|validat/.test(value))return 'review';
 if(/setting|config|polic|setup|admin/.test(value))return 'settings';
 if(/import|upload/.test(value))return 'upload';
 if(/document|dossier|certificate|evidence|quote|quotation|agreement/.test(value))return 'documents';
 if(/research|search|discovery|market|analysis/.test(value))return 'research';
 if(/molecule|material|formulat/.test(value))return 'formulations';
 if(/project|opportunit|pipeline/.test(value))return 'projects';
 if(/supplier|partner|site|sourc/.test(value))return 'partners';
 if(/customer|contact|employee|people|team|hr/.test(value))return 'people';
 if(/report|metric|scenario|performance|mis/.test(value))return 'reports';
 if(/activity|activities|follow|leave|attendance|calendar/.test(value))return 'calendar';
 if(/clinical/.test(value))return 'clinical';
 if(/portfolio|asset|service|product/.test(value))return 'portfolio';
 return 'home';
}
export default function WorkflowIcon({name,label,size=20,className=''}) {const Icon=icons[name||iconKey(label)]||icons.home;return <Icon size={size} aria-hidden="true" focusable="false" className={'workflow-icon '+className}/>;}
